import { Note } from "./Note";
import { SectionCard } from "./SectionCard";
import styles from "./Troubleshooting.module.scss";

export function TroubleshootingSection() {
  return (
    <SectionCard
      id="troubleshooting"
      ariaLabelledby="troubleshooting-h"
      title="What to Do When Something Goes Wrong"
      description="Three common situations and the fastest way to resolve each."
      className={styles.troubleshooting}
    >
      <fieldset className={styles.case} aria-labelledby="ts1-h">
        <div className={styles.head}>
          <span className={styles.num}>1</span>
          <h3 id="ts1-h" className={styles.title}>
            Extraction missed requests or pulled wrong content
          </h3>
        </div>
        <div className={styles.body}>
          <ol>
            <li>
              Click the <em>Feedback</em> tab on the right side of the screen.
            </li>
            <li>
              Select <strong>Bug</strong> and type{" "}
              <code>failed extraction</code>
            </li>
            <li>
              Submit. This goes straight to our repair team—issues are typically
              fixed within minutes of your report.
            </li>
          </ol>
        </div>
      </fieldset>

      <fieldset className={styles.case} aria-labelledby="ts2-h">
        <div className={styles.head}>
          <span className={styles.num}>2</span>
          <h3 id="ts2-h" className={styles.title}>
            Propounding discovery went to the wrong party
          </h3>
        </div>
        <div className={styles.body}>
          <strong>Step A — Re-upload &amp; verify parties</strong>
          <ol>
            <li>Upload the complaint again.</li>
            <li>
              On <strong>Step 1</strong> of the{" "}
              <strong>Source Document Review</strong> page, confirm the
              Plaintiff/Defendant are correct and your client's role is properly
              identified.
            </li>
          </ol>

          <strong>
            Step B — Prompt override (only if Step A didn't fix it)
          </strong>
          <ol>
            <li>Upload the complaint again.</li>
            <li>
              On <strong>Step 2</strong> of the{" "}
              <strong>Source Document Review</strong> page, add a cause of
              action containing this text:
            </li>
          </ol>
          <pre>
            <code>
              {`###CRITICAL PROMPT OVERRIDE###
All discovery MUST be directed to [party you want to direct the discovery to].
You represent [client name]. NEVER output a question that would support anyone
but [client name]'s positions.`}
            </code>
          </pre>

          <Note>
            Need help? Email{" "}
            <a href="mailto:support@briefpoint.ai">support@briefpoint.ai</a>,
            use the in-app Feedback tab, or call{" "}
            <a href="tel:+14155286928">415.528.6928</a>.
          </Note>
        </div>
      </fieldset>

      <fieldset className={styles.case} aria-labelledby="ts3-h">
        <div className={styles.head}>
          <span className={styles.num}>3</span>
          <h3 id="ts3-h" className={styles.title}>
            Client didn't receive an email from Briefpoint
          </h3>
        </div>
        <div className={styles.body}>
          <Note>
            Explanation: Briefpoint does <em>not</em> email your client
            directly.
          </Note>
          <ol>
            <li>
              From your matter, click <strong>Open Email</strong> or{" "}
              <strong>Copy Email</strong>.
            </li>
            <li>
              Paste the instructions into an email from your firm's email and
              send to your client.
            </li>
          </ol>
        </div>
      </fieldset>
    </SectionCard>
  );
}
